import { TableColumnSortEnum } from 'CorePackage/MainModule/enums/TableColumnSortEnum';
import { ITableColumn } from 'CorePackage/TableModule/interfaces/ITableColumn';

import { PlanListPlanIdCell } from '../components/PlanListPlanIdCell';
import { IKnmPlan } from '../interfaces/IKnmPlan';

export const initialPlanListTableColumnsErknm: ITableColumn<IKnmPlan>[] = [
  {
    id: 'id',
    name: '№ плана',
    sort: TableColumnSortEnum.NONE,
    renderCell: PlanListPlanIdCell,
  },
  {
    id: 'knoName',
    name: 'Контрольный (надзорный) орган',
    sort: TableColumnSortEnum.NONE,
  },
  {
    id: 'prosecName',
    name: 'Прокуратура',
    sort: TableColumnSortEnum.NONE,
  },
  {
    id: 'year',
    name: 'Год проведения плана',
    sort: TableColumnSortEnum.NONE,
  },
  {
    id: 'erknmStatus',
    name: 'Статус плана',
    sort: TableColumnSortEnum.NONE,
  },
  {
    id: 'signed',
    name: 'Статус подписания',
    sort: TableColumnSortEnum.NONE,
  },
  {
    id: 'knmAmount',
    name: 'Число проверок плана',
    sort: TableColumnSortEnum.NONE,
  },
  {
    id: 'disapprovedKnmAmount',
    name: 'Число отклоненных проверок плана',
    sort: TableColumnSortEnum.NONE,
  },
  {
    id: 'createdBy',
    name: 'Автор',
    sort: TableColumnSortEnum.NONE,
    nestedId: 'fullName',
  },
  {
    id: 'updatedBy',
    name: 'Автор последнего изменения',
    sort: TableColumnSortEnum.NONE,
    nestedId: 'fullName',
  },
  {
    id: 'created',
    name: 'Дата создания плана',
    sort: TableColumnSortEnum.DESC,
  },
  {
    id: 'updated',
    name: 'Дата последнего изменения плана',
    sort: TableColumnSortEnum.NONE,
  },
  {
    id: 'creationType',
    name: 'Способ подачи',
    sort: TableColumnSortEnum.NONE,
  },
];
